import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import moment from "moment";

const getNotificationsCounter = () => {
    return axios.get(`/api/notification/notification/total`, { headers: authHeaderJson() } );
};

const getNotificationsList = (entb, iTake = 0, iPage = 0, isPanel = 0) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/notification/notification/${iPage}/${iTake}/${isPanel}/list/${entb}`, { headers: authHeaderJson() } );
}

const getNotificationsListByClass = (parentId, itemId, entb, isPanel = 0) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/notification/notification/${parentId}/${itemId}/${isPanel}/list/${entb}/byclass`, { headers: authHeaderJson() } );
}

const setNotificationViewed = (notificationId, viewed) => {
    //[##PATH ROUTE##]
    let aux_viewed = viewed !== null ? `${viewed === true ? 1 : 0}` : 0;
    return axios.post(`/api/notification/notification/viewed/${notificationId}/${aux_viewed}`, { headers: authHeaderJson() } );
}

const setNotificationCompleted = (notificationId, completed) => {
    //[##PATH ROUTE##]
    let aux_completed = completed !== null ? `${completed === true ? 1 : 0}` : 0;
    return axios.post(`/api/notification/notification/completed/${notificationId}/${aux_completed}`, { headers: authHeaderJson() } );
}

const setNotificationPriority = (notificationId, priority) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/notification/notification/priority/${notificationId}/${priority}`, { headers: authHeaderJson() } );
}

const setNotificationImportant = (notificationId, important) => {
    //[##PATH ROUTE##]
    let aux_important = important !== null ? (important === true ? 1 : 0) : 0;
    return axios.post(`/api/notification/notification/important/${notificationId}/${aux_important}`, { headers: authHeaderJson() } );
}

const getTotalNotificationsBySection = () => {
    //[##PATH ROUTE##]
    return axios.get(`/api/notification/notification/section/total`, { headers: authHeaderJson() } );
}

const getNotificationDetails = (notificationId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/notification/notification/get/${notificationId}/details`, { headers: authHeaderJson() } );
}

const addAchievementComment = (achieveId, comment) => {
    //[##PATH ROUTE##]
    //return axios.post(`/api/obligacioncumplimiento/cumplimiento/comentario/add/${achieveId}?comentario=${encodeURIComponent(comment)}`, { headers: authHeaderJson() } );
    //return axios({ method: 'post', url: `/api/obligacioncumplimiento/cumplimiento/comentario/add/${achieveId}`, headers: authHeaderJson(), data : { achieveId, comment } })
    return axios.post(`/api/obligacioncumplimiento/cumplimiento/comentario/add/${achieveId}`, { id: achieveId, comentario: comment }, { headers: authHeaderJson() });
}

const addValidationComment = (achieveId, comment) => {
    //[##PATH ROUTE##]
    //return axios.post(`/api/obligacioncumplimiento/cumplimiento/validacion/comentario/add/${achieveId}?comentario=${encodeURIComponent(comment)}`, { headers: authHeaderJson() } );
    //return axios({ method: 'post', url: `/api/obligacioncumplimiento/cumplimiento/validacion/comentario/add/${achieveId}`, headers: authHeaderJson(), data : { achieveId, comment } })
    return axios.post(`/api/obligacioncumplimiento/cumplimiento/validacion/comentario/add/${achieveId}`, { id: achieveId, comentario: comment }, { headers: authHeaderJson() });
}

const getAchievementDocuments = (documentIdList) => {
    return axios.post(`/api/obligacioncumplimiento/cumplimiento/document/download`, documentIdList, { headers: authHeaderJson() });
}

const deleteAchievementDocuments = (documentId) => {
    return axios.delete(`/api/obligacioncumplimiento/cumplimiento/document/remove/${documentId}`, { headers: authHeaderJson() });
};

export {
    getNotificationsCounter,
    getNotificationsList,
    getNotificationsListByClass,
    setNotificationViewed,
    setNotificationCompleted,
    setNotificationPriority,
    setNotificationImportant,
    getTotalNotificationsBySection,
    addAchievementComment,
    addValidationComment,
    getNotificationDetails,
    getAchievementDocuments,
    deleteAchievementDocuments
}